import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const sendActivitiesToLec = (centerId: number) => {
  return restApiClient
    .url(constructApiUrl(API.centers.sendActivitiesToLec.url, { id: centerId }))
    .post()
}
